export const differenceInDaysBeetweenTwoDates = ({
  currentDate,
  finishDate
}) => {
  const millisecondsInOneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
  const diffDaysAbsolute = Math.abs(
    (currentDate.getTime() - finishDate.getTime()) / millisecondsInOneDay
  );
  const diffDaysRounded = Math.round(diffDaysAbsolute);
  return diffDaysRounded;
};
